import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as: As = "div" }) => {
  return (
    <As className={className}>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.div>
    </As>
  );
};

export default Reveal;
